var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80469 19.0792C6.80469 17.882 6.80469 17.2834 7.17661 16.9114C7.54853 16.5396 8.14713 16.5396 9.34432 16.5396H9.7676C10.5657 16.5396 10.9648 16.5396 11.2127 16.7875C11.4607 17.0355 11.4607 17.4345 11.4607 18.2326V22.4654H6.80469V19.0792Z",
    stroke: "#121217",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.54 19.9258C16.54 19.1276 16.54 18.7286 16.788 18.4806C17.0359 18.2327 17.435 18.2327 18.2331 18.2327H18.6564C19.8536 18.2327 20.4522 18.2327 20.8241 18.6046C21.196 18.9765 21.196 19.5751 21.196 20.7723V22.4654H16.54V19.9258Z",
    stroke: "#121217",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53418 22.4656H22.4651",
    stroke: "#121217",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.46 17.3861C11.46 16.1889 11.46 15.5903 11.8319 15.2183C12.2038 14.8464 12.8024 14.8464 13.9996 14.8464C15.1968 14.8464 15.7954 14.8464 16.1673 15.2183C16.5392 15.5903 16.5392 16.1889 16.5392 17.3861V22.4653H11.46V17.3861Z",
    stroke: "#121217",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5855 6.02369L15.1814 7.22535C15.2626 7.39263 15.4793 7.55307 15.6621 7.58379L16.7422 7.76472C17.4329 7.88079 17.5955 8.38604 17.0977 8.88445L16.258 9.73107C16.1159 9.87445 16.038 10.151 16.082 10.349L16.3223 11.397C16.512 12.2265 16.0752 12.5475 15.3473 12.1139L14.3349 11.5097C14.1521 11.4004 13.8508 11.4004 13.6645 11.5097L12.6521 12.1139C11.9276 12.5475 11.4874 12.2231 11.677 11.397L11.9174 10.349C11.9614 10.151 11.8836 9.87445 11.7414 9.73107L10.9017 8.88445C10.4074 8.38604 10.5665 7.88079 11.2572 7.76472L12.3372 7.58379C12.5167 7.55307 12.7334 7.39263 12.8147 7.22535L13.4106 6.02369C13.7356 5.37166 14.2638 5.37166 14.5855 6.02369Z",
    stroke: "#121217",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.a370e90671cec7ebb95520821bf16882.svg";
export { ForwardRef as ReactComponent };